import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ButtonStyled } from '@nike/nike-design-system-components';
import Flag from '~COMPONENTS/flag/Flag';

import { history } from '../../util/';

import {
  getLanguageFromLocale,
  LOCALE_USA,
  LOCALE_MEXICO,
  LOCALE_KOREAN,
  LOCALE_JAPANESE,
  COUNTRY_CODE_KOREA,
  COUNTRY_CODE_JAPAN,
  COUNTRY_CODE_MEXICO
} from './constants';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

const getCountryCode = locale => {
  switch (locale) {
    case LOCALE_KOREAN:
      return COUNTRY_CODE_KOREA;
    case LOCALE_JAPANESE:
      return COUNTRY_CODE_JAPAN;
    case LOCALE_MEXICO:
      return COUNTRY_CODE_MEXICO;
    default:
      return locale.indexOf('_') > -1 ? locale.split('_')[1].toUpperCase() : locale.split('-')[1].toUpperCase();
  }
};

export const LanguagePickerButton = ({ locale, isDark, extraClassName, redirectUrl }) => {
  const handleClick = e => {
    e.preventDefault();
    history.push(`/static/language-select${redirectUrl ? `?redirect=${redirectUrl}` : ''}`);
  };

  return (
    <ButtonStyled
      className={classnames('body-4 flex-container row', extraClassName)}
      data-desc='languagePicker__button'
      onClick={handleClick}
      background={isDark ? 'light' : 'dark'}
    >
      <div className='d-sm-ib va-sm-m pr1-sm'>
        <Flag countryCode={getCountryCode(locale)} />
      </div>
      <span>
        <TranslatedCopy id={getLanguageFromLocale(locale)} />
      </span>
    </ButtonStyled>
  );
};

LanguagePickerButton.propTypes = {
  locale: PropTypes.string,
  isDark: PropTypes.bool,
  extraClassName: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  redirectUrl: PropTypes.string
};

LanguagePickerButton.defaultProps = {
  locale: LOCALE_USA,
  isDark: false,
  extraClassName: null,
  history: null,
  redirectUrl: ''
};

export default LanguagePickerButton;
